export const SHOW_CONFIRMATION = 'SHOW_CONFIRMATION'
export const showConfirmation = (payload) => ({
    type: SHOW_CONFIRMATION,
    payload,
})

export const HIDE_CONFIRMATION = 'HIDE_CONFIRMATION'
export const hideConfirmation = (payload) => ({
    type: HIDE_CONFIRMATION,
    payload,
})
